import TermsConditionsContent from "../PrivacyAssests/TermsConditions.js";
import MetaTags from "../components/SEO/MetaTags";
import { pageConfigs } from "../utils/seo";

const TermsConditions = () => {
  return (
    <>
      <MetaTags
        title={pageConfigs.termsConditions.title}
        description={pageConfigs.termsConditions.description}
        keywords={pageConfigs.termsConditions.keywords}
        canonical={pageConfigs.termsConditions.canonical}
        noindex={pageConfigs.termsConditions.noindex}
      />
      <div className="bg-gray-100 min-h-screen p-5 flex justify-center">
      <div className="bg-gray-900 shadow-lg rounded-lg p-6 w-full max-w-5xl lg:max-w-6xl xl:max-w-7xl">
        <div dangerouslySetInnerHTML={{ __html: TermsConditionsContent }} />
      </div>
      </div>
    </>
  );
};

export default TermsConditions;
